import React from 'react';

const GameHiLow = ({ style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_23672_12017)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.7015 0.661866C15.2145 0.529495 16.5483 1.64872 16.6807 3.16172L16.7045 3.43412L18.9497 3.52688C20.4671 3.58898 21.6469 4.86977 21.585 6.38719L21.0129 20.375C20.9508 21.8925 19.671 23.0722 18.1535 23.0103L8.16196 22.6022C7.06687 22.5573 6.15032 21.8774 5.74746 20.9322L5.43907 20.9592C3.92607 21.0916 2.59223 19.9724 2.45986 18.4594L1.23968 4.51264C1.10731 2.99963 2.22653 1.66579 3.73954 1.53342L13.7015 0.661866ZM17.9009 17.1084C18.0332 18.6215 16.914 19.9553 15.401 20.0877L7.43924 20.7842C7.64793 20.9722 7.92053 21.0914 8.22301 21.1039L18.2146 21.5119C18.9043 21.5401 19.4863 21.0037 19.5145 20.314L20.0866 6.32516C20.1145 5.63572 19.5781 5.05357 18.8886 5.02521L16.8364 4.94106L17.9009 17.1084ZM3.87027 3.02772C3.18254 3.08788 2.6738 3.69417 2.73397 4.3819L3.95415 18.3286C4.01432 19.0164 4.62061 19.5251 5.30834 19.4649L15.2703 18.5934C15.958 18.5332 16.4668 17.9269 16.4066 17.2392L15.1864 3.29246C15.1262 2.60473 14.5199 2.09599 13.8322 2.15616L3.87027 3.02772ZM15.1613 17.3481L13.169 17.5224L12.9946 15.53L14.987 15.3557L15.1613 17.3481ZM12.5589 10.5491L9.9189 14.7953L6.58169 11.072L9.22165 6.82576L12.5589 10.5491ZM6.14591 6.09104L4.15353 6.26535L3.97921 4.27296L5.9716 4.09865L6.14591 6.09104Z",
      fill: "white"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_23672_12017" }, /* @__PURE__ */ React.createElement("rect", { width: "24", height: "24", fill: "white" })))
);

export { GameHiLow };
//# sourceMappingURL=GameHilow.js.map
